import { faBurgerGlass } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

import { T } from "@repo/transifex";
import { Button } from "~/components";
import { useDiningOption } from "~/providers/store/basket/hooks/use-basket";

export const DiningOptionSwitch = () => {
  const diningOption = useDiningOption();

  if (!diningOption) return null;

  return (
    <div className="mx-4 flex items-center justify-between rounded-md bg-background-secondary px-4 py-2">
      <div className="flex items-center gap-4">
        <FontAwesomeIcon icon={faBurgerGlass} />
        <p className="font-medium text-text-secondary">{diningOption.value}</p>
      </div>

      <Link to="/pos/dining-options">
        <Button variant="light">
          <T _str="Switch" />
        </Button>
      </Link>
    </div>
  );
};
